<template>
  <div class="demo-image__placeholder">
    <div class="footer_cont">
        <div class="cont">
            <div class="footer_left">
                <div class="text1">免费获取专业方案</div>
                <div class="text2"><span>选择</span><span>云百</span><img src="@img/software/Group 810.png" alt=""></div>
                <!-- <div class="text3">快速实现 <span>企业数字化转型升级！</span></div> -->
                <div class="text3"><div>快速实现</div><div class="bg">企业数字化转型升级！<div class="line"></div></div></div>
                <div class="text4">GET PROFESSIONAL SOLUTIONS FOR FREE</div>
            </div>
            <!-- <div class="footer_right">
                <div class="footer_input_top">
                    <div class="input">
                        <span>姓名：</span>
                        <input type="text" placeholder="" v-model="params.realName">
                    </div>
                    <div class="input">
                        <span>手机：</span>
                        <input type="tel" placeholder="" v-model="params.mobile">
                    </div>
                </div>
                <div class="input">
                    <span>留言：</span><input type="text" class="input" placeholder="" v-model="params.remark">
                </div>
                <div class="submit">提交信息
                <img src="@img/home/ic_xq_qd@2x.png" alt /></div>
            </div> -->
            <div class="footer_right">
            <div class="footer_input_top">
                <div class="footer_input footer_input1">
                    <span>姓名：</span>
                    <input type="text" placeholder="" v-model="params.realName">
                </div>
                <div class="footer_input footer_input2">
                    <span>电话：</span><input type="tel" placeholder="" v-model="params.mobile">
                </div>
            </div>
            <div class="footer_input footer_input3">
                <span>留言：</span><input type="text" class="footer_input3_c" placeholder="" v-model="params.remark">
            </div>
            <div class="submit_btn" @click="submit">
                提交信息
                <!-- <img src="@img/home/ic_xq_qd@2x.png" alt /> -->
            </div>
            </div>
        </div>
    </div>
    <div class="footer_info">
      <div class="footer_info_l">
        <div class="footer_logo"><img src="@img/logo.png" alt=""><b>|</b><span>引领物联网技术的发展，成为行业的领导。</span></div>
        <div class="footer_Yunbai_zh">Copyright © 2019 - 2025 Yunbai Technology. All Rights Reserved. 云百科技 版权所有</div>
        <!-- 老域名 -->
        <div class="footer_Yunbai_en">广东云百科技有限公司 | <a href="https://beian.miit.gov.cn"
          target="_blank" rel="noopener noreferrer">粤ICP备2020131390号</a></div>
      </div>
      <div class="footer_info_r">
        <div class="footer_info_r_1">
          <div class="footer_sever"> <img src="@img/component/ic_a_fwrx.png" alt=""> 服务热线：</div>
          <div class="footer_tel">0769 - 89008900</div>
        </div>
        <div class="footer_info_r_2">
          <div class="footer_sever"> <img src="@img/component/ic_a_gsdz.png" alt=""> 公司地址：</div>
          <div class="footer_addres">广东省东莞市南城街道中熙时代大厦9楼</div>
        </div>
      </div>
    </div>
    <v-slides :slideShow.sync="slideShows" @submit="CustomManager"></v-slides>
  </div>
</template>

<script>
import mixin from '@/mixin/index.js'
import vSlides from '../components/slide.vue'
export default {
  mixins: [mixin],
  components:{
    vSlides
  },
  data() {
    return {
      src: '',
      loading: false,
      slideShows:false,
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .demo-image__placeholder{
    background: #f4f6f9;
  }
// .footer_cont{
//     display: flex;
//     justify-content: space-around;
//     .footer_left{
//         .text1{
//             font-size: 40px;
//             font-family: "PingFang SC", "PingFang SC-400";
//             font-weight: 400;
//             text-align: left;
//             color: #333333;
//         }
//         .text2{
//             background: linear-gradient(96deg,#0c9aff 0%, #0c45ff 100%);
//             -webkit-background-clip: text;
//             -webkit-text-fill-color: transparent;
//             background-clip: text;
//             text-fill-color: transparent;
//             background-image: linear-gradient(96deg,#0c9aff 0%, #0c45ff 100%);
//             font-size: 60px;
//             font-family: "PingFang SC", "PingFang SC-400";
//             font-weight: 400;
//             text-align: left;
//         }
//         .text3{
//             font-size: 32px;
//             font-family: "PingFang SC", "PingFang SC-400";
//             font-weight: 400;
//             text-align: left;
//             color: #333333;
//         }
//         .text4{
//             font-size: 24px;
//             font-family: "PingFang SC", "PingFang SC-400";
//             font-weight: 400;
//             text-align: left;
//             color: rgba(153,153,153,0.60);
//         }
//     }
//     .footer_right{
//         .input{
//                 height: 46px;
//                 padding: 0 10px;
//                 background: #fff;
//                 border: 1px solid #BFBFBF;
//                 border-radius: 4px;
//                 position: relative;
//                 display: flex;
//                 input{
//                     height: 46px;
//                     width: 70%;
//                     font-size: 16px;
//                     border: none;
//                     background: #fff;
//                     color: #707070;
//                     border: none !important;
//                     outline:none;
//                     padding-left: 56px;
//                 }
//             }
//         .footer_input_top{
//             display: flex;
//             .input{
//                 height: 46px;
//                 padding: 0 10px;
//                 background: #fff;
//                 border: 1px solid #BFBFBF;
//                 border-radius: 4px;
//                 position: relative;
//                 display: flex;
//             }
            
//                 input{
//                     height: 46px;
//                     width: 70%;
//                     font-size: 16px;
//                     border: none;
//                     background: #fff;
//                     color: #707070;
//                     border: none !important;
//                     outline:none;
//                     padding-left: 56px;
//                 }
//                 span{
//                     display: inline-block;
//                     width: 48px;
//                     height: 19px;
//                     opacity: 0.8;
//                     font-size: 16px;
//                     font-weight: 400;
//                     text-align: left;
//                     color: #707070;
//                     line-height: 20px;
//                     position: absolute;
//                     left: 10px;
//                     top: 14px;
//                 }
//                 .footer_input3_c{
//                     width: 88% !important;
//                 }
//         }
//     }
// }
.footer_cont{
    padding-top: 50px;
    background: url('../../public/img/intelligentize/image 44.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    
    
    .cont{
        width: 1400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        padding-bottom: 50px;
    }
    .footer_title{
        font-family: 'PingFang SC, PingFang SC-Regular';
        font-size: 22px;
    }
    .footer_desc{
        font-family: 'PingFang SC, PingFang SC-Regular';
        font-size: 18px;
        margin-top: 10px;
        color: #727f8f;
    }
    .footer_left{
        .text1{
            font-size: 40px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 400;
            text-align: left;
            color: #333333;
        }
        .text2{
            // color: #0c45ff;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            background-image: #0c45ff;
            font-size: 60px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 400;
            text-align: left;
            vertical-align: middle;
            span{
            // background: linear-gradient(92deg,#0c9aff 0%, #0c45ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            background-image: linear-gradient(92deg,#0c9aff 0%, #0c45ff 100%);
            font-size: 60px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 400;
            text-align: left;
            // vertical-align: middle;
            }
            span:nth-child(2){
              -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
            background-image: linear-gradient(92deg,#0c45ff 0%, #0c45ff 100%);
            font-size: 60px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 400;
            text-align: left;
            }
            img{
              vertical-align: middle;
              width: 60px;
            }
        }
        .text3{
          display: flex;
            div{
              font-size: 32px;
              font-family: "PingFang SC", "PingFang SC-400";
              font-weight: 400;
              text-align: left;
              color: #333333;
            }
            .line{
              content: '';
              width: 90%;
              height: 10px;
              margin-top: -12px;
              background: #FA9A26;
            }
        }
        .text4{
            font-size: 24px;
            font-family: "PingFang SC", "PingFang SC-400";
            font-weight: 400;
            text-align: left;
            color: rgba(153,153,153,0.60);
        }
    }
    .footer_right{
    //   width: 1200px;
    //   margin: 0 auto;
      padding-bottom: 45px;
      .footer_input_top{
        display: flex;
      }
      .footer_input{
        height: 46px;
        padding: 0 0 0 10px;
        background: #fff;
        // border: 1px solid #BFBFBF;
        border-radius: 4px;
        position: relative;
        display: flex;
        &:nth-child(1){
            margin-right: 15px
        }
        input{
          height: 46px;
          width: 70%;
          font-size: 16px;
          border: none;
          background: rgba(0,0,0,0);
          color: #707070;
          border: none !important;
          outline:none;
          padding-left: 56px;
        }
        .footer_input3_c{
          width: 88% !important;
        }
        input:focus-visible{
          border: none !important;
          outline:none;
          width: 88%;
          color: #707070;
        }
        span{
          display: inline-block;
          width: 48px;
          height: 19px;
          opacity: 0.8;
          font-size: 16px;
          font-weight: 400;
          text-align: left;
          color: #707070;
          line-height: 20px;
          position: absolute;
          left: 10px;
          top: 14px;
        }
      }
      .footer_input1{width: 338px;overflow: hidden;}
      .footer_input2{width: 338px;overflow: hidden;}
      .footer_input3{width: 715px;overflow: hidden; margin-top: 24px;margin-left: 0px;}
      .submit_btn{
        margin-top: 24px;
        width: 723px;
        height: 46px;
        background: linear-gradient(96deg,#0c9aff 0%, #0c45ff 100%);
        border-radius: 4px;
        box-shadow: 0px 8px 8px 0px rgba(61,179,248,0.19); 
        font-size: 16px;
        border: 1px solid #7eb6ff;
        line-height: 48px;
        color: #fff;
        cursor: pointer;
        img{
          width: 15px;
          vertical-align: super;
        }
      }
    }
}

.footer_info{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  margin-top: 48px;
  // margin-bottom: 48px;
  padding-bottom: 48px;
  .footer_info_l{
    .footer_logo{
      text-align: left;
      margin-bottom: 21px;
      img{
        height: 32px;
        display: inline-block;
      }
      span{
        font-size: 17px;
        font-family: 'Microsoft YaHei, Microsoft YaHei-Regular';
        text-align: left;
        color: #141414;
        line-height: 38px;
        font-weight: 400;
        margin-left: 12px;
      }
      b{
        width: 10px;
        height: 22px;
        font-size: 17px;
        font-weight: 400;
        text-align: left;
        color: #e0e0e0;
        line-height: 31px;
        margin-left: 12px;
      }
    }
    .footer_Yunbai_zh{
      font-size: 14px;
      font-family: 'Microsoft YaHei, Microsoft YaHei-Regular';
      font-weight: 400;
      text-align: left;
      color: #4e5c6d;
      line-height: 22px;
      margin-bottom: 17px;
    }
    .footer_Yunbai_en{
      font-size: 14px;
      font-family: 'Microsoft YaHei, Microsoft YaHei-Regular';
      font-weight: 400;
      text-align: left;
      color: #4e5c6d;
      line-height: 22px;
      a{
        color: #4e5c6d;
        text-decoration: none;
        cursor: pointer;
        transition: color 0.3s;
        &:hover{
          color: #0063e6;
          text-decoration: underline;
        }
      }
      span{
        cursor: pointer;
      }
    }
  }
  .footer_info_r{
    .footer_info_r_1{
      .footer_sever{
        font-size: 14px;
        font-family: 'Microsoft YaHei, Microsoft YaHei-Regular';
        font-weight: 400;
        text-align: left;
        color: #161719;
        line-height: 24px;
        img{
          width: 18px;height: 18px;vertical-align: sub;
        }
      }
      .footer_tel{
        font-size: 29px;
        font-family:'Microsoft YaHei, Microsoft YaHei-Regular';
        font-weight: 400;
        text-align: left;
        color: #0063e6;
        line-height: 32px;
        letter-spacing: 4.06px;
        margin-bottom: 18px;
      }
    }
    .footer_info_r_2{
      .footer_sever{
        font-size: 14px;
        font-family: 'Microsoft YaHei, Microsoft YaHei-Regular';
        font-weight: 400;
        text-align: left;
        color: #161719;
        line-height: 24px;
        img{
          width: 18px;height: 18px;vertical-align: sub;
        }
      }
      .footer_addres{
        font-size: 14px;
        font-family: 'Microsoft YaHei, Microsoft YaHei-Regular';
        font-weight: 400;
        text-align: left;
        color: #000000;
        line-height: 22px;
      }
    }
   
  }
}
a{color: #000000;}

.submit_btn:hover {
  background: #1677ff;
  color: #fff;
  box-shadow: 0 4px 16px rgba(22, 119, 255, 0.15);
  transition: all 0.2s;
}
</style>